import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouteConstants, objectToFormData } from "../../utils";
import Input from "../FormComponents/InputComponent";
import LeftArrow from "../../assets/icons/arrow-left.svg";
import PasswordIcon from "../../assets/icons/password.svg";
import { Link } from "react-router-dom";
import { Button, Typography, message } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ForgotPassword, forgotPassword } from "./../../actions/auth";
import { APP_BASE_URL } from "./../../config/Axios";
import { FaArrowLeft } from "react-icons/fa";

const { Text, Title } = Typography;

const resetPasswordSchema = Yup.object().shape({
  email: Yup.string().email("Enter valid email").required("Email is required."),
});

message.config({
  maxCount: 3,
});

const ResetPassword = () => {
  const dispatch = useDispatch();
  const [emailSent, setEmailSent] = React.useState(false);
  const forgotPasswordResponse = useSelector(
    (state) => state.auth.forgotPassword || {},
  );

  React.useEffect(() => {
    setEmailSent(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      forgotPasswordResponse;
    if (status) {
      setEmailSent(true);
      dispatch({
        type: ForgotPassword.RESET,
      });
    } else if (status === false) {
      setEmailSent(false);
      dispatch({
        type: ForgotPassword.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forgotPasswordResponse]);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: resetPasswordSchema,
    onSubmit: (values) => {
      dispatch(
        forgotPassword(
          // objectToFormData({ ...values, redirect_url: APP_BASE_URL })
          objectToFormData({ ...values }),
        ),
      );
    },
  });
  return (
    <div className="reset-form">
      <div className="head-sec">
        <div className="icon-background">
          <img
            src={PasswordIcon}
            alt={"PasswordIcon"}
            className="passwordIcon"
          />
        </div>
        <Title level={3} className="mt2" style={{ color: "#fff" }}>
          Reset your password
        </Title>
        {emailSent ? (
          <>
            <Text className="text-dim">
              Check your inbox, we just sent you an email at{" "}
              <span className="text-white">{""}</span>
            </Text>
            <br />
            <br />
            <Text className="text-dim">
              Please check your junk or spam folder. The link is valid for 7
              days you can use it to reset your password.
            </Text>
          </>
        ) : (
          <Text className="text-dim">
            We will send you an email with a link to reset your password
          </Text>
        )}
      </div>
      {emailSent ? null : (
        <form onSubmit={formik.handleSubmit}>
          <Input
            label="Email Address"
            placeholder="Enter Work Email Address"
            name="email"
            onChange={formik.handleChange}
            value={formik.values.email}
            errMsg={formik.touched.email && formik.errors.email}
          />
          <div className="mt2">
            <Button
              type="primary"
              htmlType="submit"
              className="primaryButton"
              disabled={forgotPasswordResponse?.loading}
            >
              Reset Password
            </Button>
          </div>
        </form>
      )}
      <div className="mt2 back-arrow">
        <Link to={RouteConstants.ROOT}>
          <span style={{ marginRight: "0.5rem" }}>
            <FaArrowLeft color="var(--text-primary)" />
          </span>
          <span
            className="text-dim cursor"
            style={{ color: "var(--text-primary)" }}
          >
            {/* <img src={LeftArrow} alt={"LeftArrow"} className="leftArrow mr1" /> */}
            Back to Login
          </span>
        </Link>
      </div>
    </div>
  );
};

export default ResetPassword;
